import { PairedCostAdjustmentType, PairedCostResults } from '@aloft/toolkit-shared';

export const getPairedCostSettingsBreakdownText = (
  results: PairedCostResults,
  type: PairedCostAdjustmentType,
) => {
  const { roundingUsed, thresholdUsed } =
    Object.values(results.comps)[0]?.adjustments?.[type] ?? {};

  const roundingString = roundingUsed?.toString(true);
  const thresholdString = thresholdUsed?.toString(true);

  const formatted = [
    roundingString && roundingString !== '$1'
      ? `Adjustments are rounded to the nearest ${roundingString}. `
      : '',
    thresholdString && thresholdString !== '$0'
      ? `Adjustments are only included if the value is greater than ${thresholdString}. `
      : '',
  ].join('');

  return formatted;
};
